<template>
  <div>
    <ul>
      <li>
        <a
          href="https://www.mzcr.cz/category/ochrana-verejneho-zdravi/koupani-v-prirode/"
          target="_blank"
        >
          Ministerstvo zdravotnictví
        </a>
      </li>
      <li>
        <a href="https://www.uzis.cz" target="_blank">ÚZIS ČR</a>
      </li>
      <li>
        <a
          href="https://geoportal.gov.cz/web/guest/map?openNode=Hydrography&keywordList=inspire"
          target="_blank"
        >
          Národní geoportál INSPIRE
        </a>
      </li>
    </ul>

    <h3>Krajské hygienické stanice</h3>

    <ul>
      <li>
        <a href="http://www.hygpraha.cz/index.php?sum=NA==" target="_blank">
          HS hlavního města Prahy
        </a>
      </li>
      <li>
        <a
          href="https://www.khscb.cz/search.php?rsvelikost=sab&rstext=all-phpRS-all&rstema=11&stromhlmenu=11"
          target="_blank"
        >
          KHS Jihočeského kraje se sídlem v Českých Budějovicích
        </a>
      </li>
      <li>
        <a href="http://www.khsbrno.cz" target="_blank">
          KHS Jihomoravského kraje se sídlem v Brně
        </a>
      </li>
      <li>
        <a href="http://www.khskv.cz" target="_blank">
          KHS Karlovarského kraje se sídlem v Karlových Varech
        </a>
      </li>
      <li>
        <a href="http://www.khsjih.cz/index.php?id=159" target="_blank">
          KHS kraje Vysočina se sídlem v Jihlavě
        </a>
      </li>
      <li>
        <a href="http://www.khshk.cz" target="_blank">
          KHS Královéhradeckého kraje se sídlem v Hradci Králové
        </a>
      </li>
      <li>
        <a href="http://www.khslbc.cz" target="_blank">
          KHS Libereckého kraje se sídlem v Liberci
        </a>
      </li>
      <li>
        <a href="https://www.khsova.cz" target="_blank">
          KHS Moravskoslezského kraje se sídlem v Ostravě
        </a>
      </li>
      <li>
        <a href="https://www.khsolc.cz" target="_blank">
          KHS Olomouckého kraje se sídlem v Olomouci
        </a>
      </li>
      <li>
        <a href="https://www.khspce.cz" target="_blank">
          KHS Pardubického kraje se sídlem v Pardubicích
        </a>
      </li>
      <li>
        <a
          href="http://www.khsplzen.cz/index.php/koupani-ve-volne-pirod/kvalita-vody-koupacich-mist?view=koup&rok=2014&okres=1"
          target="_blank"
        >
          KHS Plzeňského kraje se sídlem v Plzni
        </a>
      </li>
      <li>
        <a href="https://khsstc.cz" target="_blank">
          KHS Středočeského kraje se sídlem v Praze
        </a>
      </li>
      <li>
        <a href="http://www.khsusti.cz" target="_blank">
          KHS Ústeckého kraje se sídlem v Ústí nad Labem
        </a>
      </li>
      <li>
        <a href="https://www.khszlin.cz" target="_blank">
          KHS Zlínského kraje se sídlem ve Zlíně
        </a>
      </li>
    </ul>

    <h3>Zdravotní ústavy</h3>

    <ul>
      <li>
        <a href="http://www.zuova.cz" target="_blank">
          ZU se sídlem v Ostravě
        </a>
      </li>
      <li>
        <a href="http://www.zuusti.cz" target="_blank">
          ZU se sídlem v Ústí nad Labem
        </a>
      </li>
    </ul>

    <ul>
      <li>
        <a
          href="http://www.szu.cz/centrum-hygieny-zivotniho-prostredi/odborna-skupina-hygieny-vody"
          target="_blank"
        >
          Státní zdravotní ústav
        </a>
      </li>
      <li>
        <a href="http://www.cenia.cz" target="_blank">
          Česká agentura životního prostředí
        </a>
      </li>
      <li>
        <a
          href="https://www.eea.europa.eu/themes/water/europes-seas-and-coasts/assessments/state-of-bathing-water"
          target="_blank"
        >
          European Environment Agency
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "Odkazy");
  }
};
</script>

<style scoped>
.side {
  margin: 5px;
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
  height: 91%;
  overflow: auto;
}

ul {
  padding-left: 10px;
  list-style-type: none;
}

a:link {
  text-decoration: none;
  color: black;
}

a:visited {
  text-decoration: none;
  color: black;
}

a:hover {
  text-decoration: underline;
  color: black;
}

a:active {
  text-decoration: none;
  color: black;
}
</style>
